/**
 * メールが未確認の開発者への案内（2026-09-28 creator/email-unverified・Core SEC-DEVLOGIN-01）。
 *
 *   ResendVerificationButton: 確認メールの再送（POST /v1/developers/email/resend）。上の帯（pages/AccountRecovery.tsx の VerifyEmailBanner）と
 *     操作の途中の案内（EmailUnverifiedNotice）が同じ口を使う = 押した結果の見え方をそろえる
 *   EmailUnverifiedNotice: 403 email_unverified を受けた場所（鍵の発行・プロジェクトの作成で sk_ が出なかったとき）に出す
 *     「確認メールのリンクを開いて」+ 再送のボタン。WHY 帯だけにしないか: 帯は画面の上にあり、失敗した操作の横では目に入らない
 *
 * 再送はサーバーが 1 時間 5 回・直近に送っていれば送らない（それでも 200）。ボタンは押した後「送信しました」に替わる = 連打させない
 */
import { useState, type ReactNode } from 'react';
import { api, type ApiError } from '../api';
import { errorText, useT } from '../i18n';
import { isLaunchHidden } from '../launchHidden';
import { useSession } from '../session';

export function ResendVerificationButton({ className = 'btn btn-ghost btn-sm' }: { className?: string }) {
  const { t } = useT();
  const [state, setState] = useState<'idle' | 'busy' | 'sent'>('idle');
  const [error, setError] = useState<string | null>(null);

  const resend = async () => {
    setState('busy');
    setError(null);
    try {
      await api('/v1/developers/email/resend', { method: 'POST', body: {} });
      setState('sent');
    } catch (err) {
      setState('idle');
      setError(errorText(err as ApiError));
    }
  };

  return (
    <>
      {state === 'sent' ? (
        <strong role="status">{t('emailUnverified.sent')}</strong>
      ) : (
        <button type="button" className={className} onClick={() => void resend()} disabled={state === 'busy'}>
          {state === 'busy' ? t('common.working') : t('emailUnverified.resend')}
        </button>
      )}
      {error && <span className="verify-banner-error">{error}</span>}
    </>
  );
}

/** 操作の横に出す未確認の案内。children = その場の補足（作成の画面の「キーの画面で作る」等）。無ければ既定の文 */
export function EmailUnverifiedNotice({ children }: { children?: ReactNode }) {
  const { t } = useT();
  const { developer } = useSession();
  return (
    <div className="alert alert-info" role="alert">
      <p>{children ?? t(isLaunchHidden('payouts') ? 'emailUnverified.noticeLaunch' : 'emailUnverified.notice', { email: developer?.email ?? '' })}</p>
      <ResendVerificationButton />
    </div>
  );
}
